//Built-in libraries
import { ChangeEvent } from 'react';

//Third party libraries

//Custom components
import Button from 'components/UI/Button';
import Input from 'components/UI/Form/Input';
import Modal, { ModalProps } from 'components/UI/Modal';
import ReactSelect from 'components/UI/Form/ReactSelect';
import { developmentTeamRoles } from './constants';
import { ReactSelectOption } from 'types/Constants';

//Services

//Assets andd Miscellaneous

//Component Begin

interface IAddDevelopmentTeamMemberFormProps extends ModalProps {
  modalHandler: () => void;
  team: { [key: string]: { [key: string]: any } };
  inputChangedHandler: (
    value:
      | string
      | number
      | boolean
      | ChangeEvent<HTMLInputElement>
      | undefined,
    name: string
  ) => void;
  onAddTeamHandler: () => void;
  isEditing: boolean;
  updateTeamHandler: () => void;
}

export default function AddDevelopmentTeamForm({
  modalHandler,
  isEditing,
  team,
  inputChangedHandler,
  onAddTeamHandler,
  updateTeamHandler,
  ...rest
}: IAddDevelopmentTeamMemberFormProps) {
  return (
    <Modal {...rest}>
      <h2 className='mt-0'>{`${
        isEditing ? 'Edit' : 'New'
      } Development Team`}</h2>
      <div>
        <section className='space-y-4'>
          {/* <Input
            // customClassName='col-span-3'
            label='Role'
            id='role'
            name='role'
            type='text'
            value={team.role.value}
            error={team?.role?.error}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              inputChangedHandler(e.target.value, e.target.name);
            }}
            onBlur={(e: ChangeEvent<HTMLInputElement>) => {
              inputChangedHandler(e.target.value, e.target.name);
            }}
          /> */}
          <div>
            <ReactSelect
              label='Role'
              id='role'
              name='role'
              isCreatable
              isClearable
              options={developmentTeamRoles.map((dt) => ({
                label: dt,
                value: dt,
              }))}
              defaultValue={{
                label: team.role.value,
                value: team.role.value,
              }}
              placeholder='Select or Type ...'
              error={team?.role?.error}
              onChange={(option) => {
                if (option) {
                  inputChangedHandler(
                    (option as ReactSelectOption).value,
                    'role'
                  );
                }
              }}
              onBlur={(e) => {
                inputChangedHandler(team.role.value, 'role');
              }}
            />
          </div>
          <Input
            // customClassName='col-span-3'
            label='Company Name'
            id='company-name'
            name='companyName'
            type='text'
            value={team.companyName.value}
            error={team?.companyName?.error}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              inputChangedHandler(e.target.value, e.target.name);
            }}
            onBlur={(e: ChangeEvent<HTMLInputElement>) => {
              inputChangedHandler(e.target.value, e.target.name);
            }}
          />
        </section>
        <div className='flex justify-end gap-4 mt-10'>
          <Button
            disabled={false}
            label='Cancel'
            type='button'
            btnStyle='neutral'
            onClick={modalHandler}
          />
          <Button
            label={`${isEditing ? 'Save' : 'Add'}`}
            type='button'
            btnStyle='primary'
            onClick={isEditing ? updateTeamHandler : onAddTeamHandler}
          />
        </div>
      </div>
    </Modal>
  );
}
